export const removeHashtags = (caption: string) =>
    caption
        .replace(/#[\w]+/g, "")
        .replace(/\s+/g, " ")
        .replace(/^[\s,;:.!?]+/, "")
        .trim();
